
import { ReactNode } from 'react';
import Button from 'react-bootstrap/Button';
import { Modal, ModalProps } from 'react-bootstrap';
import { Conten } from './styles';

interface MyModalProps extends ModalProps {
  show: boolean;
  content: string | ReactNode;
  onClose: () => void;
  onCloseX: () => void;
}

export function MyModal({ show, content, onClose, onCloseX, ...rest }: MyModalProps) {
  return <>
    <Modal
      show={show}
      onHide={onCloseX}
      animation={false}
      backdrop="static"
      keyboard={false}
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Conten>
        <div>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body >
            {content}
          </Modal.Body>
          <Modal.Footer>
            <Button size="sm" variant="info" onClick={onClose}>
              OK
            </Button>
          </Modal.Footer>
        </div>
      </Conten>
    </Modal>
  </>

}
